import {
  TaskGroup,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createTaskGroupMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: TaskGroup) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(`[TaskGroupHandler] INSERT TaskGroup ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskGroup,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(`[TaskGroupHandler] MODIFY TaskGroup ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskGroup,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(`[TaskGroupHandler] REMOVE TaskGroup ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.TaskGroup,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn('[TaskGroupHandler] Unknown action for TaskGroup:', action);
      }
    } catch (error) {
      log.error('[TaskGroupHandler] Handler failed:', error);
    }
  };
}
